import script from "./CateringLeads.vue?vue&type=script&setup=true&lang=js"
export * from "./CateringLeads.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import SecondaryNav from "@/components/SecondaryNav.vue";
import SecondaryTop from "@/components/SecondaryTop.vue";
script.components = Object.assign({}, { SecondaryNav, SecondaryTop }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { SecondaryNav, SecondaryTop }, script.__o.components);}